import { ReactTagManager } from 'react-gtm-ts';
import { clearGclid } from '@sc/shared-ui';

// the company uuid is the transaction id, so Google Ads can dedupe a sign-up
// reported from either the email or the SSO path
export const trackSignUpConversion = (companyUuid: string) => {
  ReactTagManager.action({
    event: 'conversion',
    send_to: 'AW-18032304049/CBgECN_coNAcELG_vJZD', // Sign-up event
    transaction_id: companyUuid,
  });

  clearGclid();
};
